import React from 'react'
import { Button, Icon, Message } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

export default ({ refetchInboundUnackedShipments }) => {
  const { t: translate } = useTranslation('pagelabels')
  return (
    <div>
      <Message
        content={`${translate('ackInboundShipments.You have no unacknowledged shipments at the moment')}.`}
      />
      <Button animated color="blue" onClick={refetchInboundUnackedShipments}>
        <Button.Content visible>
          {translate('ackInboundShipments.Refresh Shipments List')}
        </Button.Content>
        <Button.Content hidden>
          <Icon name="refresh" />
        </Button.Content>
      </Button>
    </div>
  )
}
